<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">

          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="usergroups" :items-per-page="5">
                    <template v-slot:item.details="{ item }">
                      <div class="d-flex align-center justify-center">
                        <v-dialog transition="scale-transition" origin="center center" max-width="492"
                          v-model="dialog[item.id]" content-class="deposit-withdraw-popup marketingPopup">
                          <template v-slot:activator="{ on, attrs }">
                            <div class="links text-decoration-none mr-3">
                              <div v-bind="attrs" v-on="on">
                                <v-icon color="#039de9" small>
                                  mdi-pencil-outline
                                </v-icon>
                              </div>
                            </div>
                          </template>

                          <template>
                            <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark
                              ? 'blue-darken-1'
                              : 'white-lighten-5'
                              ">
                              <v-card-title class="pb-3 text-left justify-start pl-3">
                                Edit Account Groups & Limit..
                              </v-card-title>
                              <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                                You Can Edit Account Groups & Limitations
                              </v-card-subtitle>
                              <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark
                                ? 'blue-darken-1'
                                : 'white-lighten-5'
                                ">
                                <v-row>
                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Live/Demo</legend>
                                      <v-text-field v-model="item.livedemo" disabled label="Write Here" single-line solo
                                        hide-details class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>
                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Account Type</legend>
                                      <v-text-field v-model="item.account_type_display" disabled label="Write Here"
                                        single-line solo hide-details class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>
                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Max Allowance</legend>
                                      <v-text-field v-model="item.max_allowance" label="Write Here" single-line solo
                                        hide-details class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>
                                </v-row>
                              </v-card>
                              <v-card-actions>
                                <v-row dense>
                                  <v-col cols="12">
                                    <v-btn tile @click="updateData(item)" elevation="0"
                                      class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">Update</v-btn>
                                    <v-btn tile color="#FF567F" @click="closeDialog(item)" elevation="0"
                                      class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-actions>
                            </v-card>
                          </template>
                        </v-dialog>
                        <v-icon color="#FF567F" small @click="deleteItem(item)">
                          {{ item.details2 }}
                        </v-icon>
                      </div>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ACCGROUPS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      dialog: {},
      client_account_id: null,
      headers: [
        { text: "Demo/Live", value: "livedemo", align: "start" },
        { text: "Account Type", value: "account_type_display" },
        { text: "MT5 Account Type", value: "account_type_real" },
        { text: "Max Allowance", value: "max_allowance" },
        { text: "Action", value: "details" },
      ],
    };
  },
  computed: {
    ...mapState("accgroups", ["usergroups"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    ...mapActions("accgroups", [
      ACCGROUPS__ACTIONS.USERACCGROUPS,
      ACCGROUPS__ACTIONS.UPDATEUSERACCGROUPS,
    ]),

    closeDialog(item) {
      this.$set(this.dialog, item.id, false);
      this.selectedItem = null;
    },

    updateData(item) {
      this[ACCGROUPS__ACTIONS.UPDATEUSERACCGROUPS]({
        id: item.id,
        client_account_id: this.client_account_id,
        max_allowance: item.max_allowance
      })
      this.closeDialog(item)
    }
  },
  async created() {
    this.client_account_id = this.$route.params.id
    this[ACCGROUPS__ACTIONS.USERACCGROUPS](this.$route.params.id);
  },
};
</script>
